<div class="panel-body " *ngIf="contemptMotion===undefined">
  <div class="col-md-12 panel panel-default panel-margin-bottom panel-margin-top">
      <div class="panel-title">
        Disposition Result
      </div>
      <div class="panel-body ">
        No Disposition Result information available for this allegation.
      </div>
  </div>
</div>

<div class="panel-body " *ngIf="contemptMotion!==undefined">
    <div class="col-md-12 panel panel-default panel-margin-bottom panel-margin-top">
     <div class="panel-title">
      Disposition Result
       </div>
     <div class="panel-body ">
         <div class="col-md-6 panel panel-default">
           <div class="panel panel-default "  *ngIf="contemptMotion.getDispositionDate() !== ''">
           <div class="panel-title">
            Disposition Date
           </div>
           <div class="panel-body">
               {{contemptMotion.getDispositionDate() | date:'MM/dd/yyyy'}}
           </div>
           </div>
         </div>
         <div class="col-sm-6 panel panel-default ">
           <div class="panel panel-default "  *ngIf="contemptMotion.getDispositionEoDate() !== ''">
           <div class="panel-title">
            Disposition EO Date
           </div>
           <div class="panel-body">
               {{contemptMotion.getDispositionEoDate() | date:'MM/dd/yyyy'}}
           </div>
           </div>
         </div>
         </div>
   </div>
  </div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/juvenile/allegations/allegations-additional-info/contempt-motion/disposition-contempt-motion.component.html